module.exports = __webpack_public_path__ + "static/media/rock-3-A1.png";